import React, { useEffect, useState } from "react";
import { Button, Card, DatePicker, Form, Input, message, Modal} from "antd";
import HeaderComponent from "../component/header";
import { api_verify } from "../api/verify";
import { VerifyInfo } from "../constant";
import { useNavigate } from "react-router-dom";


const VerificationPage: React.FC = () => {

    const navigate = useNavigate();
    const [cooldownSeconds, setCooldownSeconds] = useState(0);

    useEffect(() => {
        if (cooldownSeconds <= 0) {
            return;
        }

        const timerId = window.setInterval(() => {
            setCooldownSeconds((previous) => (previous > 0 ? previous - 1 : 0));
        }, 1000);

        return () => {
            window.clearInterval(timerId);
        };
    }, [cooldownSeconds]);
  
    const onFinish = (info: VerifyInfo) => {

        if (cooldownSeconds > 0) {
            message.warning({ content: `Please wait ${cooldownSeconds} second(s) before trying again.`, key: "verfiy", duration: 2 });
            return;
        }

        const count = [
            info.licensenumber,
            info.policynumber,
            info.dateofbirth,
            ].filter(value => value != null).length;

        console.log(`count = ${count}`)
        if (!info.pin && count < 2) {
            Modal.error({
                title: "Input Error",
                content: "Please fill out two of the questions.",
                });
            return
        }

        message.loading({content: "Sending verification email...", key: "verfiy",  duration: 20});
        api_verify(info)
        .then((res) => {
            if (res.bSuccess)
            {
                setCooldownSeconds(0);
                message.success({content: res.msg, key: "verfiy",  duration: 5});
                navigate("/verifyemail");
            }
            else{
                if (res.waitSeconds && res.waitSeconds > 0) {
                    setCooldownSeconds(res.waitSeconds);
                }
                message.error({content: res.msg || 'Wrong Input! Please call our office...', key: "verfiy",  duration: 5});
            }
        })
        .catch((error) => {
        console.error("An error occurred:", error.message);
        return
        });
    };

    return (
        <div>
            <HeaderComponent />
            <div className="flex justify-center items-center body-height text-style bg-emerald-100">
                <Card className="w-[400px] shadow-lg">
                    <h2 className="text-2xl font-bold text-center mb-4 text-style">Let's find your account</h2>
                    <Form
                    name="login"
                    onFinish={onFinish}
                    initialValues={{ remember: true }}
                    >
                        <Form.Item
                            className='custom-font mb-1'
                            name="lastname"
                            label="Last Name:"
                            labelAlign="left"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            rules={[
                            { required: true, message: "Please input your ID!" },
                            ]}
                        >
                            <Input className="h-6" />
                        </Form.Item>

                        <Form.Item
                            name="practicezip"
                            label="Practice Zip Code"
                            labelAlign="left"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            className='custom-font mb-3'
                            rules={[
                            { required: true, message: "Please input your Practice Zip Code!" },
                            ]}
                        >
                            <Input  className="h-6"/>
                        </Form.Item>
                        <div className="text-style ml-1 mb-3 font-bold">
                            Please fill out two of the questions below:
                        </div>

                        <Form.Item
                            name="licensenumber"
                            label="License Number"
                            labelAlign="left"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            className='custom-font mb-1 ml-4'
                            rules={[
                            { required: false },
                            ]}
                        >
                            <Input  className="h-6"/>
                        </Form.Item>
                        <Form.Item
                            name="policynumber"
                            label="Policy Number"
                            labelAlign="left"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            className='custom-font mb-1 ml-4'
                            rules={[
                            { required: false },
                            ]}
                        >
                            <Input  className="h-6"/>
                        </Form.Item>
                        <div className="ml-5 mb-2">(e.g: CH000000016, CH000000016-1..)</div>
                        <Form.Item
                            name="dateofbirth"
                            label="Date of Birth"
                            labelAlign="left"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            className='custom-font mb-5 ml-4'
                            rules={[
                            { required: false },
                            ]}
                        >
                            <DatePicker className="h-6"/>
                        </Form.Item>

                        <div className="text-style ml-1 mb-1 font-bold">
                            OR
                        </div>
                        <div className="text-style ml-1 mb-3 font-bold">
                            Provide the PIN number you received from our office
                        </div>
                        <Form.Item
                            name="pin"
                            label="PIN"
                            labelAlign="left"
                            labelCol={{ span: 3}}
                            wrapperCol={{ span: 10 }}
                            className='custom-font mb-3 ml-4'
                            rules={[
                            { required: false },
                            ]}
                        >
                            <Input  className="h-6"/>
                        </Form.Item>
                        <div className="text-style ml-1 mb-6">
                            If you are having difficulty locating your account with the information above please call our office at (800) 219-9090.  
                            We can verify you over the phone and give you a PIN that will get you started.
                        </div>
                        <Form.Item className='flex justify-center'>
                            <Button type="primary" htmlType="submit" className="w-32 text-style" disabled={cooldownSeconds > 0}>
                                {cooldownSeconds > 0 ? `Wait ${cooldownSeconds}s` : "Verify"}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default VerificationPage;